import { useEffect, Component } from "react";
import Lenis from "lenis";
import { LangProvider } from "./i18n";
import { Nav } from "./components/Nav";
import { Hero } from "./components/Hero";
import { Marquee } from "./components/Marquee";
import { Manifesto } from "./components/Manifesto";
import { Lifecycle } from "./components/Lifecycle";
import { Consulting } from "./components/Consulting";
import { Governance } from "./components/Governance";
import { Pillars } from "./components/Pillars";
import { Audiences } from "./components/Audiences";
import { QuoteBand } from "./components/QuoteBand";
import { Cta } from "./components/Cta";
import { Footer } from "./components/Footer";
import "./App.css";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { err: false };
  }
  static getDerivedStateFromError() {
    return { err: true };
  }
  render() {
    return this.state.err ? (
      <div style={{ padding: 48, fontFamily: "monospace", color: "#94A3B8" }}>
        Algo quebrou por aqui. Recarregue a página.
      </div>
    ) : (
      this.props.children
    );
  }
}

export default function App() {
  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <LangProvider>
      <ErrorBoundary>
        <div id="top" className="min-h-screen bg-ink-950 font-sans text-white antialiased">
          <Nav />
          <main>
            <Hero />
            <Marquee />
            <Manifesto />
            <Lifecycle />
            <Audiences />
            <Consulting />
            <Governance />
            <Pillars />
            <QuoteBand />
            <Cta />
          </main>
          <Footer />
        </div>
      </ErrorBoundary>
    </LangProvider>
  );
}
